import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4fe4c265"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper not mobile" }
const _hoisted_2 = { class: "links" }
const _hoisted_3 = { class: "logo" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "WildSys", -1))
const _hoisted_5 = {
  key: 0,
  class: "title"
}
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "actions" }
const _hoisted_8 = { class: "wrapper mobile only" }
const _hoisted_9 = { class: "logo" }
const _hoisted_10 = { class: "title" }
const _hoisted_11 = { class: "logo" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_13 = ["href"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

import type { PropType } from 'vue'
import LogoSVG from '@/components/design/LogoSVG.vue'
import { ref, onBeforeUnmount, onMounted } from 'vue'
import { RouterLinkProps } from 'vue-router'

interface LinkDefinition {
    to: string|RouterLinkProps;
    label: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DefaultHeader',
  props: {
    title: {
        type: String
    },
    links: {
        type: Array as PropType<LinkDefinition[]>
    }
},
  setup(__props) {

const header = ref<HTMLElement|null>(null)
const headerReduced = ref(false)
const mobileMenu = ref(false)

const props = __props

const manageScroll = function(evt: MouseEvent){
    const scrollY = window.scrollY
    headerReduced.value = (scrollY > (header.value as HTMLElement)?.offsetHeight)
}

const attachEvents = function(){
    window.addEventListener('scroll', manageScroll)
}

const dettachEvents = function(){
    window.removeEventListener('scroll', manageScroll)
}

const smoothScroll = function(anchor){
    window.scrollTo({
        top: document.body.querySelector(anchor)?.offsetTop,
        behavior: 'smooth'
    })
}

onMounted(() => attachEvents())
onBeforeUnmount(() => dettachEvents())

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["cmp header not mobile", {'reduced': headerReduced.value}]),
      ref_key: "header",
      ref: header
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "home",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (smoothScroll('#home')), ["prevent"]))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(LogoSVG, { fill: "#ffffff" })
              ]),
              _hoisted_4
            ]),
            _: 1
          }),
          (props.title)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(props.title), 1))
            : _createCommentVNode("", true),
          (props.links)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(props.links, (link) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: link }, [
                  (link.to)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: link.to,
                        class: "link"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(link.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : (link.anchor)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          href: `#${link.anchor}`,
                          class: "link"
                        }, _toDisplayString(link.label), 9, _hoisted_6))
                      : _createCommentVNode("", true)
                ], 64))
              }), 128))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_router_link, {
            to: "/contact",
            class: "button"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Contact ")
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "home",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (smoothScroll('#home')), ["prevent"]))
          }, {
            default: _withCtx(() => [
              _createVNode(LogoSVG, { fill: "#ffffff" })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_10, _toDisplayString(__props.title), 1),
        _createElementVNode("div", {
          class: "pwa toggle",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (mobileMenu.value = !mobileMenu.value))
        }, [
          _createVNode(_component_font_awesome_icon, { icon: ['fas', 'bars'] })
        ])
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["pwa menu", {'active': mobileMenu.value}])
    }, [
      _createElementVNode("div", {
        class: "close",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (mobileMenu.value = false))
      }, [
        _createVNode(_component_font_awesome_icon, { icon: ['fal', 'circle-xmark'] })
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(LogoSVG, { fill: "#ffffff" })
      ]),
      _createVNode(_component_router_link, {
        to: "/",
        class: "link"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Nos services ")
        ]),
        _: 1
      }),
      (props.links)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_12,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.links, (link) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: link }, [
                (link.to)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: link.to,
                      class: "link"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(link.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : (link.anchor)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        href: `#${link.anchor}`,
                        class: "link"
                      }, _toDisplayString(link.label), 9, _hoisted_13))
                    : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ], 64))
        : _createCommentVNode("", true),
      _hoisted_14,
      _createVNode(_component_router_link, {
        to: "/contact",
        class: "link"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Contact ")
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/company/jobs",
        class: "link"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Recrutement ")
        ]),
        _: 1
      })
    ], 2)
  ], 64))
}
}

})